import React, { useEffect, useState } from "react";
import { Box, Button,Typography, Paper, Tabs, Tab, Divider, Grid, Checkbox, FormControlLabel } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import EditIcon from '@mui/icons-material/Edit';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';

import { getListAPI } from '../../../components/pmorder/PmorderAPI';
import { setCompleteTaskButtonEnabled,setReferbackTaskButtonEnabled } from "store/slice/AppSlice";
import ProductInfo from "./ProductInfo";
import CommentMgmt from "./comment/CommentMgmt";
import FieldView2 from "core/components/layout/FieldView2";
import {updateProductInfo} from "components/product/ProductAPI";
import { updateProductObj } from 'store/slice/PharmaSlice';

export default function TaskSpaceProd() {
  const dispatch = useDispatch();
  const [pmorderList, setPmorderList] = React.useState([]);
  const [pmorderObj, setPmorderObj] = React.useState({});
  const [confirmed, setConfirmed] = useState(false);
  const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
  const { taskApiResponse } = useSelector((state) => state.appslice.wkflow);
  const [tabIndex, setTabIndex] = useState(0);
  const [enterBatchNumAndExpiryDate, setEnterBatchNumAndExpiryDate] = useState(true);
  const [batchNumber, setBatchNumber] = useState(productObj.batchnumber || "");
  const [expiryDate, setExpiryDate] = useState(productObj.expirydate ? productObj.expirydate.split('T')[0] : "");
  const [manufDate, setManufDate] = useState(productObj.manufdate ? productObj.manufdate.split('T')[0] : ""); // Add manufacturing date state
  const [editDialogOpen, setEditDialogOpen] = useState(false);

  const editValid = batchNumber.trim() !== '' && expiryDate.trim() !== '' && manufDate.trim() !== '';

  useEffect(() => {
    getListAPI(setPmorderList, () => { });

  }, []);

  useEffect(() => {
    console.log("enterBatchNumAndExpiryDate", enterBatchNumAndExpiryDate, batchNumber, expiryDate, confirmed);
    if (enterBatchNumAndExpiryDate){ // Only if batch number and expiry date are required
      if (batchNumber !== "" && expiryDate !== "" && confirmed) {
        dispatch(setCompleteTaskButtonEnabled(true));
      } else {
        dispatch(setCompleteTaskButtonEnabled(false));
      }
    }
    dispatch(setReferbackTaskButtonEnabled(true));
  },[enterBatchNumAndExpiryDate, confirmed, productObj]);

  useEffect(() => {
    pmorderList.find((pmorder) => {
      if (pmorder.productid === productObj.id) {
        setPmorderObj(pmorder);
        return true;
      }
      return false;
    });

  }, [pmorderList, productObj.id]);

  useEffect(() => {
      setExpiryDate(productObj.expirydate ? productObj.expirydate.split('T')[0] : "");
      setBatchNumber(productObj.batchnumber || "");
      setManufDate(productObj.manufdate ? productObj.manufdate.split('T')[0] : ""); // Update manufacturing date
      
      if (productObj.formname == 'Tablet' || productObj.formname == 'Capsule' || productObj.formname == 'Capsul' || productObj.formname == 'Sachet') {
        setEnterBatchNumAndExpiryDate(true);
      } else {
        dispatch(setCompleteTaskButtonEnabled(true));
        setEnterBatchNumAndExpiryDate(false);
      }
    }, [productObj]);

  const handleCheckboxChange = (e) => {
    setConfirmed(e.target.checked);
    dispatch(setCompleteTaskButtonEnabled(e.target.checked));
  };

  const handleBatchEditOpen = () => {
    // Reset form values to current product values when opening dialog
    setBatchNumber(productObj.batchnumber || "");
    setExpiryDate(productObj.expirydate ? productObj.expirydate.split('T')[0] : "");
    setManufDate(productObj.manufdate ? productObj.manufdate.split('T')[0] : "");
    setEditDialogOpen(true);
  };

  const handleBatchEditSave = () => {
    setEditDialogOpen(false);
    updateProductInfo(productObj.id,{
      batchnumber: batchNumber,
      expirydate: expiryDate,
      manufdate: manufDate // Include manufacturing date in update
    }, (response) => {
     dispatch(updateProductObj(response));
    }, (error) => {
      console.log("Error updating batch number, expiry date, and manufacturing date:", error);
    });
  };

  const handleBatchEditCancel = () => {
    // Reset form values when canceling
    setBatchNumber(productObj.batchnumber || "");
    setExpiryDate(productObj.expirydate ? productObj.expirydate.split('T')[0] : "");
    setManufDate(productObj.manufdate ? productObj.manufdate.split('T')[0] : "");
    setEditDialogOpen(false);
  };

  return (
    <Grid item lg={12} md={12} sm={12} xs={12} >
      <Grid container sx={{ width: '100%' }}>
        <Grid item lg={4} md={4} sm={4} xs={12}>
          <Box sx={{ borderRadius: 2, minHeight: '75vh', p: 0 }}>
            <Tabs
              value={tabIndex}
              onChange={(_, v) => setTabIndex(v)}
              variant="fullWidth"
              sx={{ borderBottom: 1, borderColor: 'divider' }}
            >
              <Tab label="Product Info" />
              <Tab label="Comments" />
            </Tabs>
            <Box sx={{}}>
              {tabIndex === 0 && (
                <ProductInfo maxHeight="70vh" />
              )}
              {tabIndex === 1 && (
                <Box sx={{ p: 2, minHeight: '70vh' }}>
                  <Box sx={{ backgroundColor: 'white', borderRadius: 2, p: 1 }}>
                    <CommentMgmt maxHeight="60vh" status={1} />
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </Grid>

        <Grid item lg={8} md={4} sm={4} xs={12}>
          <Grid container>
            <Grid item lg={12} md={12} sm={12} xs={12} sx={{ pt: 2 }}>
                <Grid container direction="column" sx={{ width: '100%', }}>
                  {enterBatchNumAndExpiryDate &&
                    <Grid item lg={12} md={12} sm={12} xs={12}>
                      <Grid cotainer direction="column" sx={{ width: '100%', borderRadius: 2 }}>
                        <Grid item lg={12} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", backgroundColor: 'white', p: 1, borderRadius: 2 }}>
                          <Grid container >
                            <Grid item xs={12} lg={4}>
                              <FieldView2 label="Expiry Date" value={expiryDate || "-"} />
                            </Grid>
                             <Grid item xs={12} lg={5}>
                              <FieldView2 label="Manufacture Date" value={productObj.manufdate ? productObj.manufdate.split('T')[0] : "-"} />
                            </Grid>
                            <Grid item xs={12} lg={3}>
                              <FieldView2 label="Batch Number" value={productObj.batchnumber || "-"} />
                            </Grid>
                           
                            <Grid container alignItems="top" justifyContent="flex-end" xs={12} lg={12}>
                              <Button
                                size="small"
                                onClick={handleBatchEditOpen}
                                sx={{
                                  minWidth: 0,
                                  //position: 'absolute',
                                  right: 8,
                                  bottom: 8,
                                  background: '#f5f5f5',
                                  borderRadius: '50%',
                                  p: 1,
                                }}
                                aria-label="Edit Batch/Expiry/Manufacturing Date"
                                disabled={taskApiResponse}
                              >
                                <EditIcon fontSize="small" />
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  }
                </Grid>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12} sx={{ pt: 2 }}>
              <Box sx={{ backgroundColor: "white", borderRadius: 2, p: 3, boxShadow: 1 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={confirmed}
                      onChange={handleCheckboxChange}
                      color="primary"
                      disabled={taskApiResponse && taskApiResponse.success !== undefined}
                    />
                  }
                  label="I confirm that PROD Team has taken the batch and would kick off Product Manufactoring."
                />
              </Box>
            </Grid>
          </Grid>

        </Grid>

      </Grid>
      <Dialog open={editDialogOpen} onClose={handleBatchEditCancel} maxWidth="sm" fullWidth>
        <DialogTitle>Edit Batch, Manufacturing and Expiry Details</DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <TextField
            autoFocus
            margin="dense"
            label="Batch Number"
            type="text"
            fullWidth
            variant="outlined"
            value={batchNumber}
            onChange={(e) => setBatchNumber(e.target.value)}
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Manufacturing Date"
            type="date"
            fullWidth
            variant="outlined"
            value={manufDate}
            onChange={(e) => setManufDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              max: new Date().toISOString().split('T')[0] // Manufacturing date cannot be in the future
            }}
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Expiry Date"
            type="date"
            fullWidth
            variant="outlined"
            value={expiryDate}
            onChange={(e) => setExpiryDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              min: manufDate || new Date().toISOString().split('T')[0] // Expiry date should be after manufacturing date
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleBatchEditCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleBatchEditSave} color="primary" disabled={!editValid}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}